export default "__VITE_ASSET__Bnk$UnqR__"